const footerModeTypes = {
    LIGHTMODE: "light",
    DARKMODE: "dark",
}

const layoutThemeModes = {
    LIGHTTHEME: "light",
    DARKTHEME: "dark"
}

export { footerModeTypes, layoutThemeModes };